import Vue from 'vue'
import Router from 'vue-router'
/*
import HelloWorld from '@/components/HelloWorld'
*/
import ElementTest from "../components/ElementTest";

import Page from "../components/layout/Page";
import Index from "../components/Index";
import Login from "../components/layout/Login"
import Development from "../components/base/Development"
import Tower from "../components/base/Tower"
import Floor from "../components/base/Floor"
import Flat from "../components/base/Flat"
import DRelation from "../components/base/Relation"
import Location from "../components/item/Location"
import Trade from "../components/item/Trade"
import Item from "../components/item/Item"
import Type from "../components/item/Type"
import LRelation from "../components/item/LRelation"
import Record from "../components/records/Record"

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: Page,
      children: [
        {
          path: "/",
          component: Index
        }, {
          path: "/test",
          component: ElementTest
        }, {
          path: "/development",
          component: Development
        }, {
          path: "/tower",
          component: Tower
        }, {
          path: "/floor",
          component: Floor
        }, {
          path: "/flat",
          component: Flat
        }, {
          path: "/dRelation",
          component: DRelation
        }, {
          path: "/location",
          component: Location
        }, {
          path: "/trade",
          component: Trade
        }, {
          path: "/item",
          component: Item
        }, {
          path: "/type",
          component: Type
        }, {
          path: "/lRelation",
          component: LRelation
        }, {
          path: "/record",
          component: Record
        }
      ]
    },
    {
      path: "/login",
      component: Login
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js